module.exports = __webpack_public_path__ + "static/media/Content.cb534193.svg";